
interface ThemeClasses {
  cardClass: string;
  titleClass: string;
  buttonClass: string;
  activeButtonClass: string;
  inputClass: string;
}

/**
 * Get theme-specific classes for the Recipe Generator
 */
export const getThemeClasses = (theme: string = 'default'): ThemeClasses => {
  // Default theme
  if (theme === 'default') {
    return {
      cardClass: 'border-2 border-emerald-100 shadow-md',
      titleClass: 'text-2xl font-bold text-emerald-700',
      buttonClass: 'bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded transition-colors',
      activeButtonClass: 'bg-emerald-800 text-white font-medium py-2 px-4 rounded',
      inputClass: 'border-2 border-emerald-100 rounded p-2 focus:border-emerald-300 focus:outline-none',
    };
  }
  
  // Christmas theme
  if (theme === 'christmas') {
    return {
      cardClass: 'border-2 border-red-100 shadow-md bg-gradient-to-b from-white to-red-50',
      titleClass: 'text-2xl font-bold text-red-700',
      buttonClass: 'bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded transition-colors',
      activeButtonClass: 'bg-red-800 text-white font-medium py-2 px-4 rounded',
      inputClass: 'border-2 border-red-100 rounded p-2 focus:border-red-300 focus:outline-none',
    };
  }
  
  // Elf theme
  if (theme === 'elf') {
    return {
      cardClass: 'border-2 border-green-100 shadow-md bg-gradient-to-b from-white to-green-50',
      titleClass: 'text-2xl font-bold text-green-700',
      buttonClass: 'bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded transition-colors',
      activeButtonClass: 'bg-green-800 text-white font-medium py-2 px-4 rounded',
      inputClass: 'border-2 border-green-100 rounded p-2 focus:border-green-300 focus:outline-none',
    };
  }
  
  // Fallback to default
  return {
    cardClass: 'border-2 border-emerald-100 shadow-md',
    titleClass: 'text-2xl font-bold text-emerald-700',
    buttonClass: 'bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded transition-colors',
    activeButtonClass: 'bg-emerald-800 text-white font-medium py-2 px-4 rounded',
    inputClass: 'border-2 border-emerald-100 rounded p-2 focus:border-emerald-300 focus:outline-none',
  };
};
